"use strict";

var _toConsumableArray = require("D:\\Mis Documentos\\Softcodi\\trabajos dev\\Camping Chimborazo Web\\CCH-Front\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGuaranteedMemo = void 0;
var react_1 = require("react");
/** Like react's useMemo but with guarantee that the fn
 * won't be invoked again if deps hasn't change */
function useGuaranteedMemo(fn, deps) {
  var ref = (0, react_1.useRef)();
  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map(function (v, i) {
    return v === deps[i];
  }).indexOf(false) >= 0) {
    ref.current = {
      "v": fn(),
      "prevDeps": _toConsumableArray(deps)
    };
  }
  return ref.current.v;
}
exports.useGuaranteedMemo = useGuaranteedMemo;